import React from "react";
import { Link } from "react-router-dom";
import LiveLayout from "./LiveLayout";
import { useAuth } from "@/contexts/AuthContext";
import { MessageSquare, Users, Bell } from "lucide-react";

export default function LiveMessages() {
  const { user } = useAuth();
  return (
    <LiveLayout>
      <div className="bg-[#0A192F] text-white">
        <div className="max-w-3xl mx-auto px-5 py-7">
          <div className="label-overline text-[#E63946] flex items-center gap-2"><MessageSquare className="w-4 h-4" /> Messages</div>
          <h1 className="font-display text-3xl uppercase tracking-tight mt-1">Team Communication</h1>
        </div>
      </div>
      <div className="max-w-3xl mx-auto px-5 py-10" data-testid="live-messages">
        {!user ? (
          <div className="bg-white border border-slate-200 rounded-lg p-8 text-center">
            <MessageSquare className="w-10 h-10 mx-auto text-slate-300" />
            <p className="text-sm text-slate-500 mt-3">Sign in to message your teams and coaches.</p>
            <Link to="/login" className="inline-block mt-4 bg-[#E63946] text-white text-sm font-semibold uppercase tracking-wider px-5 py-2 rounded-sm">Sign In</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {[{ icon: Users, t: "Team Chats", d: "Group threads with your roster & coaches" },
              { icon: Bell, t: "Game Alerts", d: "Lineups, game-time and final-score notifications" },
              { icon: MessageSquare, t: "Direct Messages", d: "1:1 with coaches and staff" }].map((x, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-lg p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-slate-100 grid place-items-center shrink-0"><x.icon className="w-5 h-5 text-[#0A192F]" /></div>
                <div className="flex-1"><div className="text-sm font-semibold text-[#0A192F]">{x.t}</div><div className="text-xs text-slate-400">{x.d}</div></div>
                <span className="text-[9px] uppercase tracking-wider bg-slate-100 text-slate-400 px-2 py-1 rounded-sm">Soon</span>
              </div>
            ))}
            <p className="text-center text-xs text-slate-400 pt-4">Messaging launches alongside live scoring.</p>
          </div>
        )}
      </div>
    </LiveLayout>
  );
}
